import { Injectable } from '@angular/core';
import { IID_GR_RESOURCES } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDGrResourcesQuery } from './iidGRResources.query';
import { IIDGrResourcesStore } from './iidGRResources.store';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.GR_RESOURCES)
export class IIDGrResourcesService extends CrudService<IID_GR_RESOURCES, IIDGrResourcesStore, IIDGrResourcesQuery> {

  constructor(
    protected store: IIDGrResourcesStore,
    public query: IIDGrResourcesQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
  ) {
    super(
      Topics.IID_GR_RESOURCES,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

  getDescriptionObjFromInfoDescription(infoDescription: { [key: string]: string }[]): { label: string, text: string }[] {
    return infoDescription.flatMap((desc) => {
      return Object.entries(desc).map(([key, value]) => ({
        label: key.replace(/_/g, ' '),
        text: value
      }));
    });
  }

}
